import { createFileRoute, redirect } from '@tanstack/react-router';
import { isXeroEnabled } from '@/lib/feature-flags';
import { FinanceGuard } from '@/components/finance/FinanceGuard';
import { FinanceBoard } from '@/components/finance/FinanceBoard';

/**
 * /finance/dashboards/<id> — one finance board (F-013). Un-nested from /finance/dashboards (the
 * selector) so it renders standalone; `all` is the default "My metrics" board.
 */
export const Route = createFileRoute('/finance/dashboards_/$dashboardId')({
  beforeLoad: () => {
    if (!isXeroEnabled()) {
      throw redirect({ to: '/finance', replace: true });
    }
  },
  component: () => {
    const { dashboardId } = Route.useParams();
    return (
      <FinanceGuard>
        <FinanceBoard boardId={dashboardId} />
      </FinanceGuard>
    );
  },
});
